import { Link } from 'react-router-dom';
import type { TvShow } from '@/mocks/tvShows';

const categoryNameMap: Record<string, string> = {
  action: '动作冒险',
  suspense: '悬疑惊悚',
  scifi: '科幻奇幻',
  drama: '剧情爱情',
  crime: '犯罪刑侦',
  comedy: '喜剧',
  horror: '恐怖',
};

export default function ShowCard({ show }: { show: TvShow }) {
  const mainCategory = show.categories[0];

  return (
    <Link
      to={`/detail/${show.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={show.poster}
          alt={`${show.name} 海报`}
          title={`${show.name} - ${show.englishName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 right-2 bg-background-50/90 backdrop-blur-sm rounded-md px-2 py-0.5 text-xs font-semibold text-primary-500">
          {show.rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white text-xs line-clamp-2">{show.description}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {show.name}
        </h3>
        <p className="text-xs text-foreground-400 mt-1 truncate">{show.englishName}</p>
        <div className="flex items-center gap-2 mt-2 flex-wrap">
          <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
            {categoryNameMap[mainCategory] || mainCategory}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{show.year}</span>
        </div>
      </div>
    </Link>
  );
}